export default __webpack_public_path__ + "static/media/Welcome.fd9e2f1f.svg";